import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Transcribe from './icon-transcribe.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Transcribe {...validProps} />;
}
SvgComponent.iconName = 'transcribe';

/**
 * @deprecated This is a legacy icon
 */
export const TranscribeIcon = svgIconWrapper(SvgComponent);
